import React from 'react';
import StudentProfileBody from './StudentProfile';

const StudentPerformance = () => {
    return (
        <div className="min-h-screen">
            <StudentProfileBody />
        </div>
    );
}

export default StudentPerformance;